var map = {
	"./_sdg17.png": 218,
	"./atlas-logo.png": 107,
	"./sdg12.png": 219,
	"./sdg17.png": 220,
	"./sdg17_FDI_bullet.png": 221,
	"./sdg17_debt_treemap.png": 222,
	"./world-bank-group.png": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;